import { render, staticRenderFns } from "./Inscripcionrest-docs.vue?vue&type=template&id=5056ddf8"
import script from "./Inscripcionrest-docs.vue?vue&type=script&lang=js"
export * from "./Inscripcionrest-docs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports